const name = "produto-dropdown-item";
export default {
  name,

  components: {},

  props: {
    produto: {
      type: Object,
      default: {},
    },
  },

  mounted() {
  },

  updated() {},

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
